// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--EakdZ","info-block":"_7a3fb80146--info-block--v4y5S"};